/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {

  /**
   * <h3>侧滑栏</h3>
   * <a href="../../ui_controls/bui.sidebar.html" target="_blank">demo</a> <br>
   * {{#crossLink "bui.sidebar/option"}}{{/crossLink}}: 获取设置参数 <br>
   * {{#crossLink "bui.sidebar/widget"}}{{/crossLink}}: 获取依赖控件 <br>
   * {{#crossLink "bui.sidebar/isActive"}}{{/crossLink}}: 打开的状态 <br>
   * {{#crossLink "bui.sidebar/open"}}{{/crossLink}}: 打开侧滑栏 <br>
   * {{#crossLink "bui.sidebar/close"}}{{/crossLink}}: 关闭侧滑栏 <br>
   * {{#crossLink "bui.sidebar/lock"}}{{/crossLink}}: 不允许滑动<br>
   * {{#crossLink "bui.sidebar/unlock"}}{{/crossLink}}: 允许滑动 <br>
   *  @namespace bui
   *  @class sidebar
   *  @constructor 
   *  @param {object} option  
   *  @param {string} option.id [控件id]  
   *  @param {string} [option.trigger] [点击触发侧滑的按钮]
   *  @param {string} [option.handle] [触发的区域,配合swipe可以滑动触发 ]  
   *  @param {number} [option.width] [默认宽度280]
   *  @param {number} [option.height] [ 菜单的高度 0为自适应 ]  
   *  @param {string} [option.direction] [ 菜单侧滑的方向 left | right ]  
   *  @param {boolean} [option.fullHeight] [固定高度为屏幕的高度 true | false]  
   *  @param {boolean} [option.mask] [ 侧滑的遮罩 true | false]  
   *  @param {boolean} [option.zoom] [ 保持比例缩放 默认 true | false]  
   *  @param {boolean} [option.swipe] [ 是否允许侧滑,默认允许 true | false ]  
   *  @param {boolean} [option.delay] [ 延迟触发,配合distance 例如: slide里面如果是scroll控件,则需要设置delay:true,防止随意拖动触发其它  ]  
   *  @param {number} [option.distance] [ 默认80, 拖拽大于distance才会生效,配合delay可以防止slide又有上下其它事件 ]  
   *  @param {boolean} [option.autoTrigger] [ 默认false, 滑动最大自动触发onLoad事件,配合maxDistance及onLoad事件使用 ]  
   *  @param {number} [option.maxDistance] [ 默认280, 拖拽大于maxDistance可以触发默认事件 ]  
   *  @param {function} [option.onLoad] [ 最大自动触发onLoad事件,需要设置 autoTrigger: true ]  
   *  @example
   *   html:
   *
          <div class="bui-sidebar-wrap">
            <div id="sidebar" class="bui-sidebar">
              <!-- 侧滑菜单 -->
            </div>
            <div id="page" class="bui-page">
              <a id="menu" class="bui-btn"><i class="icon-menu"></i></a>
              <!-- 正文内容 -->
            </div>
          </div>
   *      
   *   js: 
   *   
          // 初始化
          var uiSidebar = bui.sidebar({
                id: "#sidebar", 
                trigger: "#menu"
              })
   *
   *
   */
  ui.sidebar = function(option){
        var config = {
            id: "",            
            trigger:"",            
            handle:".bui-page",
            width: 280,
            height: 0,         
            position:"left",   
            fullHeight:true,       
            mask:true,      
            zoom: true,
            swipe:true,     
            delay: false,   
            distance: 80,
            autoTrigger: false,
            maxDistance: 280,
            onLoad: null
        };
        
        //方法
        var module = {
            active: active,
            isActive: isActive,
            unActive: unActive,
            open: open,
            close: close,
            lock: lock,
            unlock: unlock,
            widget: widget,
            option: options,
            config: param,
            init: init
        };

        var mode={
          left:{
            directionOpen:"swipeRight",
            directionClose:"swipeLeft"
          },
          right:{
            directionOpen:"swipeLeft",
            directionClose:"swipeRight"
          }
        }

        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.sidebar, option );
        var $id,
            el,
            $menu,
            $handle,
            $parent,
            touch = {},     //保存拖拽的坐标
            menuAnimate,
            handleAnimate,
            transition,
            position,
            menuWidth,
            menuRemWidth,
            winWidth,
            winHeight,
            uiTouch,
            uiTouchDoc,
            isActive = false;

        //初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            // 屏幕的宽度
            winWidth = document.documentElement.clientWidth; 
            winHeight = document.documentElement.clientHeight;  

            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("sidebar id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            //绑定菜单
            if( option.trigger ){
                $menu = ui.obj( option.trigger )
            }

            $handle = ui.obj( option.handle ) || $('.bui-page');

            $parent = $id.parent();

            position = option.position;
            menuRemWidth = option.zoom ? parseFloat(option.width)/100 + 'rem': parseFloat(option.width) + 'px';
            menuWidth = parseFloat(option.width) ;
            //菜单的高度为屏幕高度还是内容高度
            menuHeight = option.fullHeight ? winHeight: option.height;
            
            //初始化
            display();

            //绑定点击事件
            bind();
            //绑定拖拽事件
            drag();

            return this;
         }   

         //绑定事件
         function bind () {

            if( $menu ){
               $menu.off("click.bui").on("click.bui",function  (e) {
                  toggle();
                  e.stopPropagation();
               })
            }
            return this;

         }

         //判断是否切换
         function toggle (argument) {
           var isclick = $id.hasClass('active');

              if( isclick ){
                close();
              }else{
                open();
              }
         }

         //初始化显示的状态
         function display (argument) {
          
           //初始化各自的位置,不执行动画效果
           menuAnimate = ui.animate($id);
           handleAnimate = ui.animate($handle);

          //父层先初始化宽高
           $id.parent().css({
              "overflow-x": "hidden",
              "width":winWidth,
              "height":menuHeight
           })

           $id.css({
              "position":"absolute",
              "z-index":0,
              "width": menuRemWidth,
              "height":menuHeight,
              "overflow-y":"auto"
           });

           $handle.css({
            "position":"relative",
            "z-index":10
           })

           if( position == "left"){
              $id.css({
                "left": "0",
                "right": "auto",
                "top": 0,
                "bottom": 0 
             });

            //禁止动画,初始化位置
            menuAnimate.transition(false).left(menuWidth/2).stop();
            // transform 导致iphone6 的闪白
            handleAnimate.transition(false).right(0).stop();

           }else if(position == "right"){

            $id.css({
                "left": "auto",
                "right": 0,
                "top": 0,
                "bottom": 0 
             });

             menuAnimate.transition(false).right("100%").stop();
             handleAnimate.transition(false).left("0").stop();
           }

         }

         //开启遮罩
         function addMask (argument) {
            
           if( param.mask ){

              uiMask = ui.mask({ 
                  appendTo: param.handle,
                  opacity:0.01,
                  callback: function (argument) {
                   close();
                  }
              });

           }
         }

         //关闭遮罩
         function removeMask (argument) {
           var mask = $handle.find(".bui-mask");
           if( param.mask && mask.length ){
              mask.remove();

              $(document).off("click.bui",".bui-mask");
           }
         }

         //拖拽
         function drag () {
            if( !$parent.length ){
              return false;
            }
            
            if( param.swipe ){
              uiTouch = ui.touch({
                "id": $parent,
                "onStart": onstart,
                "onMove": onmove,
                "onEnd": onend
              });
            }
         }

         function onstart(e,touch) {
            //如果对象已经激活,则对其它对象的滑动方向不做操作
            if(ui.sidebar.activeUI&&module!==ui.sidebar.activeUI){return;}
         }

         function onmove (e,touch) {
            //如果对象已经激活,则对其它对象的滑动方向不做操作
            if( ui.sidebar.activeUI&&module!==ui.sidebar.activeUI){return;}
            if( position == "left" && touch.direction === "swipeRight"){
                  
                ui.sidebar.activeUI = module;
                //计算移动的距离
                !isActive&&requestFrame(touch);

                e.stopPropagation();
             }
            if( position == "right" && touch.direction === "swipeLeft"){
                 ui.sidebar.activeUI = module;
                //计算移动的距离
                !isActive&&requestFrame(touch);

                e.stopPropagation();
             }
         }

         function onend (e,touch) {
            //如果对象已经激活,则对其它对象的滑动方向不做操作
            if(module!==ui.sidebar.activeUI){return;}

            var moveX = Math.abs(touch.x2-touch.x1);

            //移动达到最大宽度时,自动触发事件,默认关闭,开启的话需要在回调里面手动开启跟关闭
            if( param.autoTrigger && moveX > param.maxDistance && mode[position].directionOpen == touch.direction){
                
                param.onLoad && param.onLoad.call(this,module);

                e.stopPropagation();
            }else if( moveX > param.distance && mode[position].directionOpen == touch.direction){
                open();
                e.stopPropagation();
             } else if( moveX < param.distance && mode[position].directionOpen == touch.direction){
                
                close();
                e.stopPropagation();
              } else if(mode[position].directionClose==touch.direction){
                
                close(); 
                e.stopPropagation();
            }

         }

        // 计算距离
        function requestFrame (touch) {
            var beleft = touch.x2-touch.x1;
            var moveX = Math.abs(beleft);
            //菜单在左侧
            if( position == "left"){
              var deltaX = beleft ;

              //往右滑动出现菜单
              var menuDeltaX = -menuWidth/2 + deltaX;
                  menuDeltaX = menuDeltaX > 0 ? 0:menuDeltaX;
              //往左滑动关闭菜单
              if( touch.direction == "swipeLeft"){

                deltaX = menuWidth + deltaX;
                menuDeltaX = (beleft) < -menuWidth/2 ? -menuWidth/2:(beleft);
              }
            }else if( position == "right"){
              // 菜单在右侧
              var deltaX = beleft;

              //往左滑动出现菜单
              var menuDeltaX = menuWidth + deltaX;
                  menuDeltaX = menuDeltaX > menuWidth ? menuWidth:menuDeltaX;
              //往左滑动关闭菜单
              if( touch.direction == "swipeRight"){
                
                deltaX = -menuWidth + deltaX;
                menuDeltaX = (beleft) < -menuWidth ? -menuWidth:(beleft);
              }
            }

            //设置单位转换
            menuDeltaXRem = param.zoom ? menuDeltaX/100 + 'rem': menuDeltaX+'px';
            deltaXRem = param.zoom ? deltaX/100 + 'rem': deltaX+'px';
            
            //slide里面如果是scroll控件,则需要设置delay:true,防止随意拖动触发其它
            if( param.delay && moveX > param.distance){

                uiTouch.move(menuDeltaXRem,0,"none",$id);
                uiTouch.move(deltaXRem,0,"none",$handle);
            };

            //拖动效果马上可见
            if( !param.delay ){

                uiTouch.move(menuDeltaXRem,0,"none",$id);
                uiTouch.move(deltaXRem,0,"none",$handle);
                
            };
        }


         /**
         * 打开菜单
         *  @method open
         *  @chainable
         *  @example 
            
            //显示菜单
            uiSidebar.open();
                
         */
         function open (callback) {

            if( $menu ){
              $menu.addClass('active');
            }

            //去掉滚动
            $handle.find(".bui-page").css("overflow-y","hidden");

           if( position == "left"){

              menuAnimate.transition().right("0").stop();
              handleAnimate.transition().right(menuWidth).stop();

           }else if( position == "right" ){
              
              menuAnimate.transition().right(0).stop();
              handleAnimate.transition().left(menuWidth).stop();
           }
           //新增遮罩,防止内容点击
           addMask();

           //打开的时候,对象已经激活
           isActive = true;
           ui.sidebar.activeUI = module;

           callback && callback.call(this,module);

           return this;
         }
         
         /**
         * 关闭菜单
         *  @method close
         *  @chainable
         *  @example 
            
            //关闭菜单
            uiSidebar.close();
                
         */
         function close (callback) {

            if( $menu ){
              $menu.removeClass('active');
            }
            //恢复滚动
            $handle.find(".bui-page").css("overflow-y","auto");

           if( position == "left"){

              menuAnimate.transition().left(menuWidth/2).stop();
              handleAnimate.transition().left("0").stop();
           }else if( position == "right" ){

              menuAnimate.transition().right("100%").stop();
              handleAnimate.transition().left("0").stop();
           }

           //移除遮罩
           removeMask();

           //移除激活对象
           isActive=false;
           ui.sidebar.activeUI = null;

           callback && callback.call(this,module);

           return this;

         }
              
        /**
         * 不允许滑动
         *  @method lock
         *  @chainable
         *  @example 
            
            //关闭菜单
            uiSidebar.lock();
                
         */
         function lock (argument) {
           uiTouch.off();
           return this;

         }

         /**
         * 允许滑动
         *  @method unlock
         *  @chainable
         *  @example 
            
            //关闭菜单
            uiSidebar.unlock();
                
         */
         function unlock (argument) {
           drag();
           return this;

         }

         /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiSidebarWidget = uiSidebar.widget();
            
                
         */
        
         /**
         * 是否打开
         *  @method isActive
         *  @return { boolean } [ 打开为 true | false ]
         *  @example 
            
            //是否打开
            var isActive = uiSidebar.isActive();
                
         */
         function isActive () {
            return isActive;
            
         }

        /**
         * 取消激活状态
         *  @method unActive
         *  @return { boolean } [ 打开为 true | false ]
         *  @example 
            
            //取消激活状态
            uiSidebar.unActive();
                
         */
         function unActive() {
           //移除激活对象
           isActive=false;
           ui.sidebar.activeUI = null;
         }
         
        /**
         * 激活的对象
         *  @method active
         *  @chainable
         *  @example 
            
            //关闭菜单
            var uiActive = uiSidebar.active();
                
         */
         function active () {
           
           return ui.sidebar.activeUI;

         }
        function widget(name) {
            var control = { touch: uiTouch };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiSidebar.option();

            //获取某个参数
            var id = uiSidebar.option( "id" );

            //修改一个参数
            uiSidebar.option( "fullHeight",false );

            //修改多个参数
            uiSidebar.option( {"fullHeight":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
        return module;
    };

    return ui;

})( bui || {}, libs );
